/**
 * Logger utility that suppresses debug output in production.
 *
 * - logger.debug() → development only (silent in production)
 * - logger.info()  → alias for debug (development only)
 * - logger.warn()  → always
 * - logger.error() → always
 *
 * Usage:
 *   import { logger } from "utilities/logger";
 *   logger.debug("loading pages", { projectId });
 *   logger.warn("something unexpected", err);
 *   logger.error("something broke", err);
 */

const isDebugLoggingEnabled =
  process.env.NODE_ENV !== "production" &&
  (process.env.NODE_ENV !== "test" || process.env.BOON_TEST_DEBUG_LOGS === "1");

const devOnly = isDebugLoggingEnabled
  ? (...args: unknown[]) => console.log(...args)
  : () => {};

export const logger = {
  debug: devOnly,
  info: devOnly,
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
};
